/* eslint-disable no-undef */
import Axios from 'axios';
import { protectedResources } from '../authConfig';

const endpoint = protectedResources.apiHRMobile.endpoint;
let tokenKey = '';

if (sessionStorage.getItem('AccessToken') !== null) {
  tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
}

const config = {
  headers: { Authorization: `Bearer ${tokenKey}` },
};

export async function GetOneTrustPurposes() {
  try {
    const URL = `${endpoint}/Purpose/GetOneTrustPurpose`;

    const response = await Axios.get(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function GetPPTPurposes() {
  try {
    const URL = `${endpoint}/Purpose/GetPPTPurposes`;

    const response = await Axios.get(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function GetActivePurposes() {
  try {
    const URL = `${endpoint}/Purpose/GetPurposesActive`;

    const response = await Axios.get(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function SetPurpose(body = {}) {
  try {
    const URL = `${endpoint}/Purpose/SetPurpose`;

    const response = await Axios.post(URL, body, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function SortPurpose(body = []) {
  try {
    const URL = `${endpoint}/Purpose/Sorting`;

    const response = await Axios.post(URL, body, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function DeletePurpose({ purposeId = '' }) {
  try {
    const URL = `${endpoint}/Purpose/DeletePurpose?purposeId=${purposeId}`;

    const response = await Axios.delete(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function SetUserConsentAgreement(body = {}) {
  try {
    const URL = `https://privacyportal-eu.onetrust.com/request/v1/consentreceipts`;

    const tokenRes = await GetUserConsentAgreementToken();

    body = {
      requestInformation: tokenRes?.apiToken || '',
      ...body,
    };

    const response = await Axios.post(URL, body);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.response?.data;
  }
}

export async function GetUserConsent({ idOrEmail = '' }) {
  try {
    const URL = `${endpoint}/Purpose/GetUserConsent?identifier=${idOrEmail}`;

    const response = await Axios.get(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function GetUserConsentAgreementToken() {
  try {
    const URL = `${endpoint}/Purpose/Config`;

    const response = await Axios.get(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function SetUserConsentAgreementToken(body = {}) {
  try {
    const URL = `${endpoint}/Purpose/SetConfig`;

    const response = await Axios.post(URL, body, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}

export async function GetOneTrustPurposesById() {
  try {
    const URL = `${endpoint}/Purpose/GetOneTrustPurposeById`;

    const response = await Axios.get(URL, config);
    return (await response?.data) || undefined;
  } catch (error) {
    throw error?.message;
  }
}
